<template>
    <media-library-item 
            class="media-library-folder"
            v-bind:name-editor-placeholder="resource('MediaLibrary_RenameFolder_Placeholder')"
            v-bind:name="name" 
            v-on:item-clicked="$emit('folder-selected')"
            v-on:item-double-clicked="$emit('folder-navigated')"
            v-on:item-renamed="rename($event)"
    >
        <i class="far fa-folder-open fa-3x"></i>
    </media-library-item>
</template>

<script>
    import mediaApi from '../../../Api/media-library';
    
    import getResource from '../../../Util/resources';
    
    import {error as errorNotification } from "../Util/notifications";

    import MediaLibraryItem from './BaseMediaLibraryItem.vue';
    
    export default {
        name: "media-library-folder",
        components:{
            MediaLibraryItem
        },
        methods: {
            rename(newName) {
                const vm = this;
                
                mediaApi.renameFolder({
                    newName: newName,
                    id: vm.id
                }).then(((res) => {
                    vm.$emit('folder-renamed', res.name)
                }), errorNotification);
            },
            resource(name){
                return getResource(name);
            }
        },
        props: {
            name: {
                type: String,
                required: true
            },
            id: {
                type: String,
                required: true
            }
        }
    };
</script>

<style scoped>
    
</style>
